import React from "react";

import { NavLink } from "react-router-dom";
import { ADMIN_ACCOUNT_PATH } from "../../constants/paths";

import MdLogOut from "react-ionicons/lib/MdLogOut";
import MdHome from "react-ionicons/lib/MdHome";

const AdminLinks = ({ signOut }) => {
  return (
    <div>
      <NavLink
        to={ADMIN_ACCOUNT_PATH}
        exact
        activeClassName="active"
        className="px-4 py-2 flex rounded-md hover:bg-gray-200 m-2 text-gray-700 hover:text-gray-900"
      >
        <MdHome className="fill-current"></MdHome>
        <span className="ml-4">Mi cuenta</span>
      </NavLink>
      <NavLink
        to=""
        exact
        activeClassName="active"
        className="px-4 py-2 flex rounded-md hover:bg-gray-200 m-2 text-gray-700 hover:text-gray-900"
        onClick={(e) => {
          e.preventDefault();
          if (window.confirm("Seguro que deseas cerrar sesión")) signOut();
        }}
      >
        <MdLogOut className="fill-current"></MdLogOut>
        <span className="ml-4">Cerrar sesión</span>
      </NavLink>
    </div>
  );
};

export default AdminLinks;
